import { type ColumnOptions } from "interfaces";

export const columnOptions: ColumnOptions[] = [
  {
    name: "Name",
    width: 13,
    isSortable: true,
  },
  {
    name: "Members",
    width: 2,
    isSortable: false,
  },
  {
    name: "",
    width: 1,
    isSortable: false,
  },
];
